<template>
  <div class="w-full z-10">
    <div v-if="serieName" class="bg-blue rounded-t-md">
      <p class="text-white text-[16px] font-ubuntu px-2 pt-2 pb-3 font-medium">
        {{ $t('formation.courses.serie') + serieName }}
      </p>
    </div>
    <div :class="{ ' rounded -mt-1 ': serieName }">
      <article
        class="pt-calendarSession"
        :class="`pt-calendarSession-${theme} pt-calendarSession__${type}`"
      >
        <div v-if="type === 'sessionList'">
          <ul>
            <li
              v-for="(item, index) in displayedItems"
              :key="item.slug"
              :class="{ 'pt-calendar__dense': dense }"
            >
              <div v-if="item.lectures" class="flex align-middle content-center mb-1">
                <WidgetsAppleCalendar
                  v-if="item.date"
                  class="shadow"
                  dense
                  :date="item.date"
                  :event="true"
                />
              </div>
              <div class="pt-calendarSession__content">
                <h2
                  class="pt-calendarSession__description"
                  :class="`pt-calendarSession-${theme}__description`"
                  @click="scrollBlockEmit({ scroll: 'blockSection', tab: index })"
                >
                  {{ item.title }}
                </h2>

                <span v-if="ratehours[index]" class="text-gray">
                  <icon name="pt-clock" />
                  <span class="text-sm font-semibold"> {{ ratehours[index] }} h </span>
                </span>
              </div>
            </li>
          </ul>
          <button v-if="list.length > 3" class="my-2 link" type="button" @click="toggleShow">
            {{ !showMore ? $t('ui.label.seeMore') : $t('ui.label.seeLess') }}
            <icon
              :name="!showMore ? 'pt-arrow-down' : 'pt-arrow-up'"
              class="text-xl ml-0 text-blue"
            />
          </button>
        </div>

        <ul v-else-if="type === 'noDate'">
          <li :class="{ 'pt-calendarSession__dense': dense }">
            <Labels
              label-type="text-gray"
              :items="$t('formation.detail.session_onlinecourse_duration')"
            />
          </li>
        </ul>
      </article>
    </div>
  </div>
</template>

<script>
import { dateWithDayAndMonth, timeWithHours, isSameOrBeforeDate } from '@/utils/helpers/date';
import { firstLetterUppercase, uppercase } from '~/utils/helpers/string';

export default {
  name: 'PtCalendarSessions',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    titleBanner: {
      type: String,
      default: ''
    },
    serieName: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'light',
      validator: val => ['dark', 'light', 'transparent'].includes(val)
    },
    type: {
      type: String,
      default: 'sessionList',
      validator: val => ['sessionList', 'noDate'].includes(val)
    }
  },

  setup(props) {
    const { scrollBlockDetailEvents } = useEventsEntities();
    const showMore = ref(false);
    const store = useStore();
    const displayedItems = computed(() => (showMore.value ? props.list : props.list.slice(0, 3)));
    const ratehours = computed(() =>
      props.list.map(item => {
        const lectures = item.lectures;
        if (Array.isArray(lectures) && lectures.length > 0) {
          const firstTime = lectures[0].event_time;
          const lastTime = lectures[lectures.length - 1].event_time;
          if (firstTime == null || lastTime == null) {
            return null;
          }
          return `${firstTime?.slice(0, 5)} - ${lastTime?.slice(0, 5)}`;
        }
        return null;
      })
    );

    const toggleShow = () => {
      showMore.value = !showMore.value;
    };

    const scrollBlockEmit = tab => {
      store.dispatch('tools/setTabSectionIndex', tab.tab);
      scrollBlockDetailEvents(tab);
    };

    return {
      showMore,
      uppercase,
      ratehours,
      toggleShow,
      timeWithHours,
      displayedItems,
      scrollBlockEmit,
      isSameOrBeforeDate,
      dateWithDayAndMonth,
      firstLetterUppercase
    };
  }
};
</script>

<style src="./style.scss" lang="scss"></style>
